import { Box, Typography } from '@mui/material';
import { StoreResult } from 'api/client-domain/client-domain.types';

type RelatedLocationHeaderProps = {
  relatedLocation: Partial<StoreResult>;
};

const RelatedLocationHeader = ({
  relatedLocation,
}: RelatedLocationHeaderProps) => {
  return (
    <Box display="flex" alignItems="center">
      <Typography
        variant="h3"
        sx={{
          wordBreak: 'break-all',
        }}
      >
        <Box component="span" mr={1}>
          {relatedLocation?.title}
        </Box>
      </Typography>
    </Box>
  );
};

export default RelatedLocationHeader;
